/**
 * Verkäufernummer und Artikelnummer als Eingabe „17/5“ (Kasse O3, Suche im Verlauf O6). Der Trenner ist Pflicht: Eine
 * reine Ziffernfolge bleibt immer ein Code (10 Ziffern) und wird nie als Nummernpaar gedeutet.
 */
export interface SellerItemRef {
  sellerNumber: number;
  itemNo: number;
}

const MAX_SELLER_NUMBER = 99_999;
const MAX_ITEM_NO = 9999;

/** Erkennt `17/5`, `17-5` und `17 5`; `null` bei allem anderen (auch bei Nummern außerhalb 1–99999 bzw. 1–9999). */
export function parseSellerItemRef(input: string): SellerItemRef | null {
  const match = /^\s*(\d{1,5})\s*[/\- ]\s*(\d{1,4})\s*$/.exec(input);
  if (match === null) return null;
  const sellerNumber = Number(match[1]);
  const itemNo = Number(match[2]);
  if (sellerNumber < 1 || sellerNumber > MAX_SELLER_NUMBER) return null;
  if (itemNo < 1 || itemNo > MAX_ITEM_NO) return null;
  return { sellerNumber, itemNo };
}
